/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_NewInputs */

const en_mk_tut_sc_new = /** @type {(inputs: Mk_Tut_Sc_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new issue from anywhere`)
};

const id_mk_tut_sc_new = /** @type {(inputs: Mk_Tut_Sc_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat issue baru dari mana pun`)
};

/**
* | output |
* | --- |
* | "Create a new issue from anywhere" |
*
* @param {Mk_Tut_Sc_NewInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_new = /** @type {((inputs?: Mk_Tut_Sc_NewInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_NewInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_new(inputs)
	return en_mk_tut_sc_new(inputs)
});